import { useParams, Link } from 'react-router-dom';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { categories, articles } from '@/mocks/articles';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.category === slug);

  if (!category) {
    return (
      <main className="pt-20 min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-heading font-bold text-foreground-900 mb-3">分类未找到</h1>
          <Link to="/" className="text-primary-500 hover:text-primary-600 text-sm">返回首页</Link>
        </div>
      </main>
    );
  }

  return (
    <main className="pt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <Breadcrumb items={[{ label: category.name, href: `/category/${category.slug}` }]} />

          <header className="mb-10">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                <i className={`${category.icon} text-lg`}></i>
              </div>
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                {category.name}
              </h1>
              <span className="text-sm text-foreground-500 font-label">{category.nameJa}</span>
            </div>
            <p className="text-sm text-foreground-600 ml-13 pl-13">{category.description}</p>
          </header>

          <div className="flex gap-2 mb-8 flex-wrap">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
                  cat.slug === slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200/70'
                }`}
              >
                <i className={`${cat.icon} mr-1.5`}></i>
                {cat.name}
              </Link>
            ))}
          </div>

          {categoryArticles.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 pb-16">
              {categoryArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
                <i className="ri-inbox-line text-2xl text-foreground-400"></i>
              </div>
              <p className="text-foreground-500 text-sm">该分类暂无内容，敬请期待</p>
            </div>
          )}
        </div>
      </div>
    </main>
  );
}